<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import VisitCardTagGroup from './VisitCardTagGroup.vue';
import LaisVisitorCheckinBadge from 'dashboard/components-next/LaisVisitorCheckinBadge.vue';
import VisitPopoverMenu from './VisitPopoverMenu.vue';

const props = defineProps({
  visit: { type: Object, default: () => ({}) },
  statusLabel: { type: String, default: '' },
  statusVariant: { type: String, default: 'neutral' },
  showConfirm: { type: Boolean, default: false },
  showReschedule: { type: Boolean, default: false },
  showFinish: { type: Boolean, default: false },
  showOffer: { type: Boolean, default: false },
  showCancel: { type: Boolean, default: true },
  showMoreActions: { type: Boolean, default: true },
  isPool: { type: Boolean, default: false },
  offerLabel: { type: String, default: 'Enviar link de proposta' },
  rescheduleLabel: { type: String, default: 'Reagendar visita' },
  blocked: { type: Boolean, default: false },
  checkedIn: { type: Boolean, default: false },
});

const emit = defineEmits([
  'confirm',
  'reschedule',
  'cancel',
  'cancelGroup',
  'finish',
  'offer',
  'actions',
]);

const clientName = computed(
  () =>
    props.visit.contact?.name ||
    props.visit.clientName ||
    'Cliente não informado'
);
const propertyTitle = computed(
  () => props.visit.imovel?.titulo || props.visit.title || ''
);
const propertyAddress = computed(
  () =>
    props.visit.imovel?.endereco ||
    props.visit.address ||
    propertyTitle.value ||
    'Endereço não informado'
);
const propertyRegion = computed(() =>
  [
    props.visit.imovel?.bairro,
    props.visit.imovel?.cidade,
    props.visit.imovel?.estado,
  ]
    .filter(Boolean)
    .join(', ')
);
const propertyCode = computed(
  () =>
    props.visit.imovel?.shortId ||
    props.visit.imovel?.short_id ||
    props.visit.imovel?.id ||
    props.visit.imovelId ||
    ''
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <article
    class="rounded-lais border border-lais-border bg-white p-4 shadow-lais-card"
  >
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0 flex-1">
        <h3 class="truncate text-[15px] font-semibold text-lais-text">
          {{ clientName }}
        </h3>
      </div>
      <VisitPopoverMenu
        :visit="visit"
        :show-confirm="showConfirm"
        :can-cancel="showCancel"
        :can-reschedule="showReschedule || blocked"
        :is-pool="isPool"
        :include-more-actions="showMoreActions"
        @confirm="emit('confirm')"
        @cancel="emit('cancel')"
        @cancel-group="emit('cancelGroup')"
        @reschedule="emit('reschedule')"
        @more-actions="emit('actions')"
      />
    </div>
    <VisitCardTagGroup
      class="mt-3"
      :status-label="statusLabel"
      :status-variant="statusVariant"
      :primary-market="Boolean(visit.primaryMarket)"
      :tenant-living="Boolean(visit.tenantLiving)"
      :third-party="Boolean(visit.thirdParty)"
      :agent-support="Boolean(visit.agentSupport)"
    />
    <div
      class="mt-3 min-h-[78px] cursor-pointer text-[13px] text-lais-text-body"
    >
      <p class="font-semibold text-lais-text">
        {{ propertyAddress }}
      </p>
      <p v-if="propertyRegion" class="mt-1 text-lais-text-muted">
        {{ propertyRegion }}
      </p>
      <p v-if="propertyTitle && propertyTitle !== propertyAddress" class="mt-1">
        {{ propertyTitle }}
      </p>
      <p v-if="propertyCode" class="mt-1 text-lais-text-muted">
        Cód. Imóvel {{ propertyCode }}
      </p>
    </div>
    <LaisVisitorCheckinBadge class="mt-2" :checked="checkedIn" />
    <div class="mt-4 grid gap-2 sm:grid-cols-2">
      <button
        v-if="showConfirm"
        type="button"
        class="rounded-lais bg-lais-primary px-3 py-2 text-[13px] font-semibold text-white"
        @click="emit('confirm')"
      >
        Confirmar visita
      </button>
      <button
        v-if="showReschedule || blocked"
        type="button"
        class="rounded-lais border border-lais-border px-3 py-2 text-[13px] font-semibold text-lais-primary"
        @click="emit('reschedule')"
      >
        {{ rescheduleLabel }}
      </button>
      <button
        v-if="showFinish"
        type="button"
        class="rounded-lais border border-lais-border px-3 py-2 text-[13px] font-semibold text-lais-text"
        @click="emit('finish')"
      >
        Finalizar visita
      </button>
      <button
        v-if="showOffer"
        type="button"
        class="rounded-lais border border-lais-border px-3 py-2 text-[13px] font-semibold text-lais-text"
        @click="emit('offer')"
      >
        {{ offerLabel }}
      </button>
    </div>
  </article>
</template>
